import styled from 'styled-components'

export const SectionContainer = styled.div`
  margin: 4.5rem auto 5rem;

  @media screen and (min-width: 768px) {
    margin: 6rem auto 5rem;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2.3rem 4.5rem;

  @media screen and (min-width: 768px) {
    margin: 0 2.3rem 6rem;
  }
`

export const Description = styled.div`
  max-width: 67rem;
  margin: 0 auto;
  padding: 0 3.6rem;
`
